import JobPortal from '../views/JobPortalBase/JobPortal';
/* import JobPortalItem from '../components/JobPortal/JobPortalItem'; */

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: url_prefix + '/employer/portal',
    name: 'jobportal',
    component: JobPortal,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      breadcrumb: function() {
        return 'Job Portal';
      },
    },
  },
  /*   {
    path: url_prefix + '/employer/portal/:id',
    name: 'jobportalItem',
    component: JobPortalItem,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      breadcrumb: function() {
        return 'Job Portal';
      },
    },
  }, */
];
